import React from 'react';
import { Image, Text, View } from 'react-native';
import { img_icon_search, img_icon_search_x } from '../../utils/ImagesManagementUtils';
import { textPrimary_10_3, textPrimary_9_3 } from '../SimulatorsComponents/AuxiliaryComponent/TextComponent/TextStyle';

//= ========================================================================

const SearchContact = ({
  globJSON,
  simPlatform,
  subCategoryId,
  withCloseIcon,
  inputText,
  marginTop,
}) => {
  const { colors } = globJSON.configurations.theme;
  const myStyles = {
    container: {
      width: 'auto',
      flexDirection: 'row',
      justifyContent: 'space-between',
      paddingHorizontal: 7,
      height: 23,
      marginTop,
    },
    textInputStyle: {
      width: 189,
      borderRadius: 6.4,
      backgroundColor: colors.light_elements_color,
      borderColor: colors.border_color,
      borderWidth: 1,
    },
    hintStyle: {
      color: withCloseIcon ? colors.primary_font_color : colors.secondary_font_color,
      marginVertical: 'auto',
      paddingHorizontal: 7,
    },
    xIconStyle: {
      margin: 'auto',
      width: 12,
      height: 12,
      marginLeft: 172,
      marginTop: -17,
    },
    searchImage: {
      width: 22,
      height: 22,
      tintColor: colors.links_icons_color,
      alignSelf: 'center',
    },
    row: {
      flexDirection: 'row',
    },
  };
  return (
    <View style={myStyles.container}>
      <View style={myStyles.textInputStyle}>
        <View style={myStyles.row}>
          <Image
            fadeDuration={0}
            style={myStyles.searchImage}
            source={img_icon_search}
          />
          <Text style={[textPrimary_10_3(globJSON, simPlatform), myStyles.hintStyle]}>
            {inputText}
          </Text>
        </View>
        {withCloseIcon && (
          <Image
            fadeDuration={0}
            style={myStyles.xIconStyle}
            source={img_icon_search_x}
          />
        )}
      </View>
      <Text style={[textPrimary_9_3(globJSON, simPlatform), { margin: 'auto' }]}>
        {globJSON.configurations.services[subCategoryId].recipient.cancel}
      </Text>
    </View>
  );
};
export default SearchContact;
